import React from 'react';
// import PropTypes from 'prop-types';
import {
  useActiveAccount,
  useProfile,
  useUpdateAccount,
} from 'modules/auth/hooks';
import Card from 'partial/components/Card';
import Button from 'partial/components/Button';
import { toastWarning } from 'react-geek-toast';
import { showDrawer } from 'partial/components/Modal';
import placeholder from 'assets/images/placeholder.svg';
import { uploadPhoto } from 'partial/form/FormPhotoDnd';
import PageWrapper from 'partial/components/PageWrapper';
import GenericInfo, { InfoItem } from 'partial/components/GenericInfo';
import BankDetailsModal from 'core-modules/profile/modals/BankDetailsModal';
import { openChangePassword } from 'modules/auth/modals/ChangePasswordModal';
import Table from 'partial/components/Table';

const MAP_PASSWORD_LABEL = {
  LIVE: 'Production Mode Password',
  TEST: 'Test Mode Password',
};

function Profile() {
  const [list] = React.useState([
    {
      id: '1',
      location: 'Philippines (13)',
      device: 'Chrome - Mac OS',
      ip_address: '120.29.111.80',
      time: '1 minute ago',
      session: 'Current Session',
    },
    {
      id: '2',
      location: 'Philippines (13)',
      device: 'Chrome - Mac OS',
      ip_address: '120.29.108.48',
      time: 'last year',
      session: 'Expired',
    },
  ]);
  const tableFormat = React.useMemo(() => {
    return [
      { label: 'Location', key: 'location', id: 'location' },
      { label: 'Device', key: 'device', id: 'device' },
      { label: 'IP Address', key: 'ip_address', id: 'ip_address' },
      { label: 'Time', key: 'time', id: 'time' },
      { label: '', key: 'session', id: 'session' },
    ];
  }, []);
  const [profile] = useProfile();
  const [account] = useActiveAccount();
  const [isAccountUpdating, updateAccount] = useUpdateAccount();
  const handleEnable2Fa = () => {
    toastWarning('Access Denied! Please contact your administrator');
  };
  const handleChangePassword = () => {
    openChangePassword();
  };
  const [isUploading, setIsUploading] = React.useState(false);
  const handleChangeLogo = async () => {
    setIsUploading(true);
    const photo = await uploadPhoto();
    setIsUploading(false);
    if (!photo) return;
    updateAccount({
      ...account,
      logo: photo,
    });
  };
  const actionEditBankDetails = React.useMemo(() => {
    const edit = () => {
      showDrawer({
        size: 'xs',
        title: 'Edit Bank Details',
        content: (onClose) => (
          <BankDetailsModal data={account} onClose={onClose} />
        ),
      });
    };
    return (
      <div>
        <Button size="xs" onClick={edit}>
          Edit
        </Button>
      </div>
    );
  }, [account]);

  const actionSignOut = React.useMemo(() => {
    const edit = () => {
      showDrawer({
        size: 'xs',
        title: 'Edit Bank Details',
        content: (onClose) => (
          <BankDetailsModal data={account} onClose={onClose} />
        ),
      });
    };
    return (
      <div>
        <Button size="xs" onClick={edit}>
          Sign out all other sessions
        </Button>
      </div>
    );
  }, [account]);
  return (
    <PageWrapper>
      <div className="grid grid-cols-2 gap-6">
        <Card
          label="Details"
          // renderAction={actionEditProfile}
        >
          <div className="py-4 space-y-3">
            <div className="h-32 w-64 mx-auto">
              <img
                className="h-full w-auto mx-auto object-center object-contain"
                src={account.logo || placeholder}
                // src={'https://ucarecdn.com/5ec42f59-533d-4aab-82f2-20d013e386cb/-/resize/256x/' || profile.logo}
                alt={account?.name}
              />
            </div>
            <div className="flex justify-center">
              {isUploading ? (
                <div className="text-center loader-wrapper">
                  <div className="text-gray-500 text-xs uppercase tracking-wide">
                    Uploading...
                  </div>
                  <div className="loaderBar w-32">
                    <div className="loaderBarInner" />
                  </div>
                </div>
              ) : (
                <Button
                  size="xs"
                  onClick={handleChangeLogo}
                  disabled={isUploading || isAccountUpdating}
                >
                  {isUploading ? 'Uploading...' : 'Change Logo'}
                </Button>
              )}
            </div>
            {!account.logo ? (
              <div className="px-6 text-center">
                <div className="text-center inline-flex mx-auto bg-danger-50 text-danger-500 p-3 rounded">
                  Please upload your organization logo
                </div>
              </div>
            ) : null}
          </div>
          <dl className="sm:divide-y sm:divide-gray-200">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Organization
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 text-right">
                {account?.name}
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Email</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 text-right">
                {profile?.email_address}
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Name</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 text-right">
                {profile?.name}
              </dd>
            </div>
          </dl>
        </Card>
        <div className="space-y-6">
          <Card label="Security">
            <dl className="sm:divide-y sm:divide-gray-200">
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Multi-Factor
                </dt>
                <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  <span className="flex-grow text-gray-400 text-right">
                    Disabled
                  </span>
                  <span className="ml-4 flex-shrink-0">
                    <button
                      type="button"
                      className="bg-white rounded-md font-medium text-primary-600 hover:text-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                      onClick={handleEnable2Fa}
                    >
                      Enable
                    </button>
                  </span>
                </dd>
              </div>
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  {MAP_PASSWORD_LABEL[account.env_mode] || 'Password'}
                </dt>
                <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  <span className="flex-grow">&nbsp;</span>
                  <span className="ml-4 flex-shrink-0">
                    <button
                      type="button"
                      className="bg-white rounded-md font-medium text-primary-600 hover:text-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                      onClick={handleChangePassword}
                    >
                      Change Password
                    </button>
                  </span>
                </dd>
              </div>
            </dl>
          </Card>
          <Card label="Bank Details" renderAction={actionEditBankDetails}>
            <GenericInfo data={account}>
              <InfoItem value="bank_name" label="Bank" />
              <InfoItem value="bank_account_name" label="Account Name" />
              <InfoItem value="bank_account_number" label="Account Number" />
            </GenericInfo>
          </Card>
        </div>
        <Card
          label="Login Sessions"
          className="col-span-2 hidden"
          renderAction={actionSignOut}
        >
          <Table data={list} format={tableFormat} />
        </Card>
      </div>
    </PageWrapper>
  );
}

Profile.propTypes = {};

export default Profile;
